import { Expose } from "class-transformer";
import { IsNumber, IsBoolean, IsString, IsOptional } from "class-validator";

export class Printer {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  @IsOptional()
  description!: string;
  @Expose()
  @IsBoolean()
  isDefault!: boolean;
}
